import React, { useState, useEffect }                               from "react";
import { useAtom }                                                  from "jotai";
import useColorScheme                                               from "_common/hooks/useColorScheme";
import { logoutUser }                                               from "_components/pages/auth/apis";
import Presentation                                                 from "./presentation";
import { useRouter }                                                from "next/router";
import { checkForAppleDevice, checkForFirefox }                     from "_common/utils";
import { storeEvent }                                               from "_analytics/index";
import { useGetLoggedIn, useGetProfileData }                        from "_common/hooks/auth";
import { useSetProfileData, useSetLoggedIn }                        from "_common/hooks/auth";
import { useSetLoginPopup }                                         from "_common/hooks/global";
import { notificationPageCountAtom, notificationPageCountFlagAtom } from "_root/jotai/notifications";
import { useGetDrawer, useSetDrawer, useGetAppLocale }              from "_common/hooks/global";
import { useGetDeviceTheme, useSetDeviceTheme }                     from "_common/hooks/global";
import { useSetDarkMode, useGetDarkMode, useSetInterestialPopup }   from "_common/hooks/global";
import { isPageRoute }                                              from "_common/utils";

const component = () => {
	const colorScheme                                   = useColorScheme ();
	const toggleDarkMode                                = useSetDarkMode ();
	const darkMode                                      = useGetDarkMode ();
	const isDeviceTheme                                 = useGetDeviceTheme ();
	const setSystemTheme                                = useSetDeviceTheme ();
	const [ installPrompt, setInstallEvent ]            = useState ( undefined );
	const [ showLocalePage, setShowLocalePage ]         = useState ( false );
	const [ showAppearanceMenu, setShowAppearanceMenu ] = useState ( false );
	const [ state, setState ]                           = useState ( {
		isCleverTap : true,
		isLivePage  : true
	} );

	const appLocale   = useGetAppLocale ();
	const showDrawer  = useGetDrawer ();
	const userProfile = useGetProfileData ();

	const isLoggedIn          = useGetLoggedIn ();
	const router              = useRouter ();
	const setLoginPopup       = useSetLoginPopup ();
	const setLoggedIn         = useSetLoggedIn ();
	const setProfile          = useSetProfileData ();
	const setDrawer           = useSetDrawer ();
	const setInterestialPopup = useSetInterestialPopup ();
	const isActivatePage      = isPageRoute ( { page: "activate", router } );

	const [ , setNotificationPageCount ]     = useAtom ( notificationPageCountAtom );
	const [ , setNotificationPageCountFlag ] = useAtom ( notificationPageCountFlagAtom );

	const hideLocalePage = val => {
		setShowLocalePage ( val );
	};

	const fireNotificationPopUp = () => {
		return null;
	};

	useEffect ( () => {
		window.addEventListener ( "beforeinstallprompt", event => {
			event.preventDefault ();
			setInstallEvent ( event );
		} );
	}, [] );

	useEffect ( () => {
		if ( checkForAppleDevice () || checkForFirefox () ) {
			setState ( { isCleverTap: false, isLivePage: false } );
		}
	}, [] );

	useEffect ( () => {
		if ( isActivatePage ) {
			toggleDarkMode ( true );

			return;
		}
		if ( isDeviceTheme && colorScheme ) {
			toggleDarkMode ( colorScheme === "dark" );
		}
	}, [ colorScheme, isDeviceTheme ] );

	const handlePopup = () => {
		closeDrawer ();
		setInterestialPopup ( true );
	};

	const handleLoginPopup = () => {
		storeEvent ( "Authentication", "Log_In", "side_nav" );
		closeDrawer ();
		setLoginPopup ( true );
		setInterestialPopup ( false );
	};

	const goHome = () => {
		storeEvent ( "Side_Nav", "Clicked", "HOME" );
		setDrawer ( false );
		router.push ( "/" );
	};

	const goModFeed = () => {

		setDrawer ( false );
		router.push ( "/modfeed" );
	};

	const closeDrawer = () => {
		setDrawer ( false );
	};

	const __logoutUser = async () => {
		storeEvent ( "Authentication", "Log_Out", "side_nav" );

		const logoutData = { isFrom: "Hamburger" };

		await logoutUser ( logoutData );

		setProfile ( undefined );
		setLoggedIn ( false );
	};

	const logoutUserGoogle = /* googleData*/ () => {
		// storeEvent("Side_Nav", "Clicked", "Logout");

		// const logoutData = { isFrom: "Hamburger" };

		// logoutUser ( logoutData );
		// goHome();
		/* console.log ( "CXCXCXCXXC", googleData ); */
	};

	const openLocaleSelector = val => {
		storeEvent ( "Side_Nav", "Clicked", "Change_Language" );
		setShowLocalePage ( val );
	};

	const handleDownloadClick = ( action, link ) => {
		let a = document.createElement ( "a" );

		a.href = link;
		a.setAttribute ( "target", "_blank" );
		a.click ();
	};

	const handleAppearanceMenu = () => {
		setShowAppearanceMenu ( !showAppearanceMenu );
	};

	const { isCleverTap, isLivePage } = state;

	const handleSelectedTheme = theme => {

		switch ( theme ) {
			case "system":
				setSystemTheme ( true );
				storeEvent ( "Side_Nav", "Clicked", "Appearance_System" );
				break;

			case "dark":
				toggleDarkMode ( true );
				setSystemTheme ( false );
				storeEvent ( "Side_Nav", "Clicked", "Appearance_dark" );
				break;

			case "light":
				toggleDarkMode ( false );
				setSystemTheme ( false );
				storeEvent ( "Side_Nav", "Clicked", "Appearance_Light" );
				break;

			default:
				break;
		}
		setDrawer ( false );
		setShowAppearanceMenu ( false );
	};

	const goToNotifications = () => {
		setNotificationPageCountFlag ( true );
		setNotificationPageCount ( null );
		router.push ( "/notifications" );
	};

	return (
		<Presentation
			appLocale             = { appLocale }
			closeDrawer           = { closeDrawer }
			darkMode              = { darkMode }
			deviceTheme           = { isDeviceTheme }
			fireNotificationPopUp = { fireNotificationPopUp }
			goHome                = { goHome }
			goModFeed             = { goModFeed }
			goToNotifications     = { goToNotifications }
			handleAppearanceMenu  = { handleAppearanceMenu }
			handleDownloadClick   = { handleDownloadClick }
			handleLoginPopup      = { handleLoginPopup }
			handlePopup           = { handlePopup }
			handleSelectedTheme   = { handleSelectedTheme }
			hideLocalePage        = { hideLocalePage }
			installPromptEvent    = { installPrompt }
			isCleverTap           = { isCleverTap }
			isLivePage            = { isLivePage }
			isLoggedIn            = { isLoggedIn }
			logoutUser            = { __logoutUser }
			logoutUserGoogle      = { logoutUserGoogle }
			setShowLocalePage     = { openLocaleSelector }
			showAppearanceMenu    = { showAppearanceMenu }
			showDrawer            = { showDrawer }
			showLocalePage        = { showLocalePage }
			storeEvent            = { storeEvent }
			userProfile           = { userProfile }
		/>

	);
};

export default component;
